var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"ytube__iframe",attrs:{"id":`yt-${_vm.video.id}`,"src":_vm.url,"type":"text/html","width":_vm.width,"height":_vm.height,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }